import { render, staticRenderFns } from "./YourDataIsSafeTemplate.vue?vue&type=template&id=0c6c185e"
import script from "./YourDataIsSafeTemplate.vue?vue&type=script&lang=js"
export * from "./YourDataIsSafeTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports